export const SECTIONS = ["morse", "braille", "letter-number", "semaphore", "pigpen", "signal-flags"] as const;
